import { UserPermissionsModel, UserSettingsModel } from './models'

export enum UserSettingsAction {
  loadCurrentUserSettings = 'loadCurrentUserSettings',
  loadMfaConfiguration = 'loadMfaConfiguration',
  setEmailMfaEnabled = 'setEmailMfaEnabled',
  loadCurrentUserPermissions = 'loadCurrentUserPermissions',
  }

export enum UserSettingsMutation {
  setCurrentUserFeatureSwitches = 'setCurrentUserFeatureSwitches',
  setEmailMfaEnabled = 'setEmailMfaEnabled',
  setCurrentUserPermissions = 'setCurrentUserPermissions',
}

export enum UserSettingsGetter {
  currentUserSettings = 'currentUserSettings',
  isFeatureOn = 'isFeatureOn',
  isEmailMfaEnabled = 'isEmailMfaEnabled',
  currentUserPermissions = 'currentUserPermissions',
  hasPermission = 'hasPermission',
}

export interface UserSettingsState {
  currentUserSettings: UserSettingsModel
  currentUserPermissions: UserPermissionsModel[]
}
